import {
  parseWorkspaceScope,
  workspaceCampaignBase,
  type WorkspaceNavTab,
} from '@/api/workspaceScope';

export const SAPYON_AGENT_LABEL = 'Sapyon Agent';
export const SAPYON_AGENT_TAB = 'sapyon-agent';

export function appendSapyonAgentTab(
  tabs: WorkspaceNavTab[],
  pathname: string,
  isSuperAdmin: boolean
): WorkspaceNavTab[] {
  if (!isSuperAdmin) return tabs;
  const scope = parseWorkspaceScope(pathname);
  if (scope?.platform !== 'amazon') return tabs;
  const to = `${workspaceCampaignBase(scope)}/${SAPYON_AGENT_TAB}`;
  if (tabs.some((tab) => tab.to === to)) return tabs;
  return [...tabs, { label: SAPYON_AGENT_LABEL, to, end: true }];
}

export function sapyonAgentDeniedPath(profileId: string): string {
  if (!profileId) return '/accounts';
  return `/accounts/${encodeURIComponent(profileId)}/campaigns/dashboard`;
}
